// src/pages/CompaniesPage.tsx

import React from "react";
import { useQuery } from "@apollo/client";
import { GET_COMPANIES } from "../graphql/queries";
import {
  Container,
  Card,
  CardContent,
  Typography,
  CircularProgress,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";

interface User {
  id: string;
  name: string;
}

interface Company {
  id: string;
  name: string;
  users: User[];
}

interface GetCompaniesData {
  companies: Company[];
}

export default function CompaniesPage(): React.JSX.Element {
  const { loading, error, data } = useQuery<GetCompaniesData>(GET_COMPANIES);

  if (loading) return <CircularProgress />;
  if (error)
    return <Typography color="error">{`Error: ${error.message}`}</Typography>;

  return (
    <Container maxWidth="md">
      <Typography variant="h4" gutterBottom>
        Companies
      </Typography>
      {data && data.companies.length > 0 ? (
        data.companies.map((company) => (
          <Card key={company.id} style={{ marginBottom: "1rem" }}>
            <CardContent>
              <Typography variant="h5">{company.name}</Typography>
              <Typography variant="h6">Users:</Typography>
              <List>
                {company.users.map((user) => (
                  <ListItem key={user.id}>
                    <ListItemText primary={user.name} />
                  </ListItem>
                ))}
              </List>
            </CardContent>
          </Card>
        ))
      ) : (
        <Typography>No companies found</Typography>
      )}
    </Container>
  );
}
